import { Extension } from '@tiptap/core';
import { NodeSelection, Plugin, type Selection } from '@tiptap/pm/state';

/** Een hele pagina is geselecteerd (cover, team, investering…): de blauwe rand na een klik. */
export function wholePageSelected(selection: Selection): boolean {
  return selection instanceof NodeSelection && selection.$from.depth === 0 && selection.node.attrs.id != null;
}

/** Toetsen die een geselecteerde node vervangen of verwijderen, of er een losse alinea naast zetten. */
const PAGE_EDIT_KEYS = new Set(['Backspace', 'Delete', 'Enter']);

/**
 * ProseMirror vervangt een geselecteerde node bij de eerste toets: één letter na een klik
 * op de cover verving de hele coverpagina door een losse alinea. Een pagina verwijder je
 * in de paginalijst (met bevestiging); in het document blijft een geselecteerde pagina heel.
 * Velden in de pagina (titel, teamleden) hebben hier geen last van: hun invoer gaat niet
 * via ProseMirror.
 */
export const QuotePageInputGuard = Extension.create({
  name: 'quotePageInputGuard',
  // Vóór de keymaps van Tiptap, anders verwijdert Backspace de pagina al.
  priority: 1000,

  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          handleTextInput: (view) => wholePageSelected(view.state.selection),
          handleKeyDown: (view, event) =>
            PAGE_EDIT_KEYS.has(event.key) && wholePageSelected(view.state.selection),
          handlePaste: (view) => wholePageSelected(view.state.selection),
          handleDOMEvents: {
            cut: (view, event) => {
              if (!wholePageSelected(view.state.selection)) return false;
              event.preventDefault();
              return true;
            },
          },
        },
      }),
    ];
  },
});
